import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from '@stateManagement/TranslationContext';
import { mediaContactStyles as classes } from './MediaContactStyles';
import { getTranslation } from '@helpers/languageTranslations';
import { Heading, LazyLoadContainer, Text } from '@web-for-marketing/react-ui';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { PressRoomImages } from '@helpers/staticImages/pressRoom';

export function MediaContact({ translations }) {
    const { prefixStringWithBaseUrl } = useStaticValues();
    const { selectedLanguageTranslation } = useTranslation();

    const aboutGeotabTranslation = getTranslation(selectedLanguageTranslation, 'aboutGeotab');

    return (
        <Grid container>
            <LazyLoadContainer component={Grid} item sm={12} md={4}>
                <Grid css={classes.mediaIconContainer}>
                    <img
                        data-src={prefixStringWithBaseUrl(PressRoomImages.mediaContact)}
                        src=''
                        css={classes.mediaIcon}
                        aria-hidden='true'
                        alt={translations.mediaContact.imageAlt}
                    />
                </Grid>
                <Heading variant='h4' component='p' css={classes.bodySubtitle}>
                    {translations.mediaContact.title}
                </Heading>
                {translations.mediaContact.name ? (
                    <Text variant='body2' color='tertiary'>
                        {translations.mediaContact.name}
                    </Text>
                ) : null}
                {translations.mediaContact.role ? (
                    <Text variant='body2' color='tertiary'>
                        {translations.mediaContact.role}
                    </Text>
                ) : null}
                <Text variant='body2' color='tertiary'>
                    {translations.mediaContact.email}
                </Text>
            </LazyLoadContainer>
            <Grid item sm={12} md={8}>
                <Heading variant='h4' component='h2' css={[classes.bodySubtitle, classes.fixMargin]}>
                    {aboutGeotabTranslation.main}
                </Heading>
                <Text
                    color='tertiary'
                    variant='body2'
                    css={classes.content}
                    dangerouslySetInnerHTML={{ __html: aboutGeotabTranslation.content }}
                />
            </Grid>
        </Grid>
    );
}

MediaContact.propTypes = {
    translations: PropTypes.objectOf(Object).isRequired,
};
